<template>
  <div class="title-menu-header">
    <h1 class="view-title">{{ title }}</h1>
    <div class="action-icons">
      <TechnologyAssetsAddNew />
      <TechnologyAssetsFilterModal @filter-refetch="$emit('filterRefetch')" />
      <SearchAsYouType @quick-search-refetch="$emit('quickSearchRefetch')"/> 
    </div>
  </div>
</template>
<script setup lang="ts">
  import TechnologyAssetsFilterModal from '@/components/TechnologyAssetsFilterModal.vue';
  import TechnologyAssetsAddNew from '@/components/TechnologyAssetsAddNew.vue';
  import SearchAsYouType from '@/components/SearchAsYouType.vue';
  import { defineProps, defineEmits } from 'vue';
 
  defineProps({
    title: String
  })
  defineEmits(['filterRefetch', 'quickSearchRefetch'])
  
</script>